import React from "react";
import './CaseStudyAi.css';
import { motion } from 'framer-motion';
import chatgptfigma from '../Assets/images/casestudy/aicasechatgptfigma.png';
import figma from '../Assets/images/casestudy/aicaseoverview.png';
import promptsystem from '../Assets/images/casestudy/aicasemenu.png';
import iterationthread from '../Assets/images/casestudy/aicaseiterationthread.png';



export default function CaseStudyAi() {
    return (
      <>
        {/* === Video Hero Section === */}
        <section className="caseStudyVideoHeader">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="caseStudyBgVideo"
          >
            <source src={require('../Assets/Videos/casestudy/aicasevideo.mp4')} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
  
          <div className="caseStudyOverlay">
            <h1 className="caseStudyTitle">
              <span>Co-Creating With AI</span>
            </h1>
            <p className="caseStudyIntro">
              An exploration of how I use tools to increase the pace, scope, and quality of my design work.
            </p>
          </div>
        </section>
  
        {/* === Main Case Study Content Section === */}
        <section className="caseStudyContainer">   
        <section className="caseStudyContentWrapper">
          <motion.div
            className="caseStudyBlock"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            <ul className="caseStudyList">
              <li>Used AI to design and structure a job-seeking portfolio from scratch</li>
              <li>Created and iterated on UI/UX components with conversational feedback loops</li>
              <li>Wove together technical + creative workflows in real-time with AI assistance</li>
            </ul>
          </motion.div>

      <motion.section className="caseStudySection" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, ease: 'easeOut' }}>
        <div className="caseStudyBlock">
          <h2 className="caseStudySubheading">🧠 My Mindset Around Tools</h2>
          <p className="caseStudyText">
            I use tools to extend the scope of what i can create and save time and expand what’s possible.
            Working with AI like ChatGPT helps me move fluidly between design ideation, code, copywriting, and layout. I treat the system like an
            endlessly patient collaborator who can execute, explain, and suggest.
          </p>
        </div>
      </motion.section>

      <motion.section className="caseStudySection" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, ease: 'easeOut' }}>
        <div className="caseStudyContent">
          <div className="caseStudyTextBlock">
            <h2 className="caseStudySubheading">🛠️ Project Setup</h2>
            <p className="caseStudyText">
              From the beginning of my UX portfolio. I set up the file structure, naming conventions, and initial codebase together with premaking layouts and templates for the ai to follow in creating pages. Knowing the limitations of the tool to self-refer and keep track of changes, this was important for it to keep track of file locations, prior changes and the overall direction of the project.
            </p>
          </div>
          <img src={figma} alt="Folder and project structure" className="caseStudyImage" />
        </div>
      </motion.section>

      <motion.section className="caseStudySection" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, ease: 'easeOut' }}>
        <div className="caseStudyContent">
          <div className="caseStudyTextBlock">
            <h2 className="caseStudySubheading">🧩 Prompt Systems & Iteration Loops</h2>
            <p className="caseStudyText">
              My design process includes building prompt systems. I use conversational iterations to scaffold entire sections:
              for example, asking ChatGPT to follow my style guide and directory structure while building out new components, providing information about their purpose and screenshots of my designs. This has proved to create a very fast workflow.
            </p>
          </div>
          <img src={promptsystem} alt="Prompting system and ChatGPT interaction" className="caseStudyImage" />
        </div>
      </motion.section>

      <motion.section className="caseStudySection" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, ease: 'easeOut' }}>
        <div className="caseStudyContent">
          <div className="caseStudyTextBlock">
            <h2 className="caseStudySubheading">🎨 Design Decisions in Context</h2>
            <p className="caseStudyText">
              I don’t just use AI for code — I talk through design intent. Whether exploring visual hierarchies, scrolling animations,
              or deciding on a color system, I write out my design logic and let AI give back tailored alternatives, implementation suggestions, or tuning the existing styles.
            </p>
          </div>
          <img src={chatgptfigma} alt="Design ideation notes with ChatGPT and visual tools" className="caseStudyImage" />
        </div>
      </motion.section>

      <motion.section className="caseStudySection" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, ease: 'easeOut' }}>
        <div className="caseStudyContent">
          <div className="caseStudyTextBlock">
            <h2 className="caseStudySubheading">🔁 Feedback & Refinement</h2>
            <p className="caseStudyText">
              Easy iteration with clear guidelines is where AI really takes the manual labor out of creation. I’ll post a screenshot or describe a user experience, and ChatGPT will return
              suggestions based on accessibility, layout principles, or UX best practices.
            </p>
          </div>
          <img src={iterationthread} alt="Chat-based design iterations" className="caseStudyImage" />
        </div>
      </motion.section>
      </section>
      </section>
      <footer className="caseStudyFooter">
        <a href="/" className="caseStudyBackLink">← Back to Home</a>
      </footer>
    </>
  );
}
